<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask" @click.self="$emit('close')">
      <div class="modal-container">
        <div class="modal-body text-center">
          <img
            src="/images/pgx-logo.png"
            alt="pgx-logo"
            width="50"
            class="mb-3"
          />
          <h5 class="modal-title">{{ title }}</h5>
          <p class="modal-text">{{ body }}</p>
          <div class="modal-actions">
            <button class="btn btn-gradient" @click="$emit('close')">
              Mengerti
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: {
      type: String,
      default: "Transaksi dalam tinjauan",
    },
    body: {
      type: String,
      default:
        "Nominal transaksi Anda masuk dalam daftar tinjauan kepatuhan dan memerlukan pemeriksaan manual oleh tim kami. Dana belum dikirimkan. Transaksi akan diteruskan setelah peninjauan selesai. Kami juga telah mengirimkan pemberitahuan ke email Anda.",
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  width: 100%;
  max-width: 440px;
  margin: 16px;
  padding: 28px 24px;
  background: linear-gradient(180deg, #1a1a2e 0%, #12121f 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
}

.modal-title {
  color: #fff;
  font-weight: 600;
  margin-bottom: 12px;
}

.modal-text {
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 24px;
}

.modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
